import { useEffect, RefObject } from 'react'

export function useCheckIconRendered(iRefs: RefObject<HTMLElement>[]): void {
    useEffect(() => {
        iRefs?.forEach(iconElement => {
            const content = window.getComputedStyle(iconElement.current, '::before').content

            if (content === 'none') {
                iconElement.current.setAttribute('class', 'far fa-circle')
            }
        })
    }, [iRefs])
}
